import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,500&family=Inter:wght@300;400;500;600;700&display=swap');
  :root { --g:#173B34; --o:#E4572E; --c:#F6F2EC; --d:#222222; --line:#EDE9E2; }

  .mr { font-family: 'Inter', sans-serif; color: var(--d); }
  .mr-progress { height: 3px; background: var(--line); border-radius: 2px; margin-bottom: 32px; overflow: hidden; }
  .mr-progress-fill { height: 100%; background: linear-gradient(90deg, var(--g), var(--o)); border-radius: 2px; transition: width .4s ease; }

  /* FORMATION */
  .mr-formation { max-width: 720px; margin: 0 auto; }
  .mr-part { margin-bottom: 44px; }
  .mr-eyebrow { display: inline-flex; align-items: center; gap: 8px; font-size: 10.5px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--o); margin-bottom: 14px; }
  .mr-eyebrow::before { content: ''; width: 18px; height: 2px; background: var(--o); display: inline-block; }
  .mr-part h2 { font-family: 'Playfair Display', serif; font-size: clamp(20px, 2.5vw, 26px); color: var(--g); font-weight: 700; line-height: 1.2; margin-bottom: 14px; }
  .mr-part p { font-size: 15px; color: #555; line-height: 1.75; margin-bottom: 14px; font-weight: 300; }
  .mr-part strong { color: var(--d); font-weight: 600; }

  .mr-hl { background: rgba(23,59,52,0.07); border-left: 3px solid var(--g); border-radius: 0 12px 12px 0; padding: 16px 20px; margin: 16px 0; font-size: 14.5px; color: #333; line-height: 1.65; }
  .mr-hl.orange { background: rgba(228,87,46,0.07); border-left-color: var(--o); }

  .mr-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin: 16px 0; }
  .mr-gi { background: #fff; border: 1px solid var(--line); border-radius: 12px; padding: 16px 18px; }
  .mr-gi-ico { font-size: 20px; margin-bottom: 8px; }
  .mr-gi-title { font-size: 13.5px; font-weight: 700; color: var(--g); margin-bottom: 5px; }
  .mr-gi-desc { font-size: 12.5px; color: #777; line-height: 1.55; }

  .mr-reseaux { display: grid; grid-template-columns: repeat(2,1fr); gap: 10px; margin: 16px 0; }
  .mr-reseau { background: #fff; border: 1px solid var(--line); border-radius: 12px; padding: 14px 16px; }
  .mr-reseau-head { display: flex; align-items: center; gap: 8px; margin-bottom: 7px; }
  .mr-reseau-ico { font-size: 18px; }
  .mr-reseau-name { font-size: 13.5px; font-weight: 700; color: var(--g); }
  .mr-reseau-cible { font-size: 11.5px; font-weight: 600; color: var(--o); margin-bottom: 5px; }
  .mr-reseau-desc { font-size: 12px; color: #777; line-height: 1.55; }

  .mr-pilliers { display: flex; flex-direction: column; gap: 0; margin: 14px 0; }
  .mr-pillier { display: flex; gap: 12px; padding: 12px 14px; background: #fff; border: 1px solid var(--line); position: relative; }
  .mr-pillier:first-child { border-radius: 12px 12px 0 0; }
  .mr-pillier:last-child { border-radius: 0 0 12px 12px; border-top: none; }
  .mr-pillier:not(:first-child):not(:last-child) { border-top: none; }
  .mr-pillier-num { width: 28px; height: 28px; border-radius: 50%; background: var(--g); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0; margin-top: 1px; font-family: 'Playfair Display', serif; }
  .mr-pillier strong { display: block; font-size: 13.5px; color: var(--d); margin-bottom: 3px; }
  .mr-pillier span { font-size: 12.5px; color: #777; line-height: 1.55; }

  .mr-erreurs { display: flex; flex-direction: column; gap: 8px; margin: 14px 0; }
  .mr-erreur { display: flex; align-items: flex-start; gap: 10px; padding: 12px 14px; background: rgba(220,38,38,0.04); border: 1px solid rgba(220,38,38,0.15); border-radius: 10px; font-size: 13.5px; color: #444; line-height: 1.55; }
  .mr-erreur-x { color: #DC2626; font-weight: 700; flex-shrink: 0; font-size: 15px; margin-top: 1px; }

  /* CTA LÉA */
  .mr-lea {
    background: linear-gradient(135deg, #173B34 0%, #0E2820 100%);
    border-radius: 24px; padding: 40px 36px; margin-top: 8px;
    position: relative; overflow: hidden;
    box-shadow: 0 20px 48px rgba(23,59,52,0.25);
  }
  .mr-lea::before { content: ''; position: absolute; top: -80px; right: -80px; width: 280px; height: 280px; border-radius: 50%; background: rgba(228,87,46,0.12); pointer-events: none; }
  .mr-lea::after { content: ''; position: absolute; bottom: -60px; left: -40px; width: 180px; height: 180px; border-radius: 50%; background: rgba(246,242,236,0.03); pointer-events: none; }

  .mr-lea-eyebrow { font-size: 10.5px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--o); margin-bottom: 14px; display: flex; align-items: center; gap: 8px; position: relative; z-index: 2; }
  .mr-lea-eyebrow::before { content: ''; width: 20px; height: 2px; background: var(--o); }

  .mr-lea h2 { font-family: 'Playfair Display', serif; font-size: clamp(22px, 3vw, 30px); color: #fff; font-weight: 700; line-height: 1.2; margin-bottom: 14px; position: relative; z-index: 2; }
  .mr-lea h2 em { font-style: italic; color: var(--o); }

  .mr-lea-desc { font-size: 15px; color: rgba(246,242,236,0.6); line-height: 1.75; margin-bottom: 28px; max-width: 520px; position: relative; z-index: 2; font-weight: 300; }

  .mr-lea-features { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 30px; position: relative; z-index: 2; }
  .mr-lea-feat { background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.09); border-radius: 12px; padding: 14px 16px; }
  .mr-lea-feat-ico { font-size: 18px; margin-bottom: 7px; }
  .mr-lea-feat-title { font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 4px; }
  .mr-lea-feat-desc { font-size: 12px; color: rgba(246,242,236,0.45); line-height: 1.5; }

  /* CODE PROMO */
  .mr-promo {
    background: rgba(228,87,46,0.12); border: 1px solid rgba(228,87,46,0.3);
    border-radius: 14px; padding: 18px 20px; margin-bottom: 28px;
    position: relative; z-index: 2;
    display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
  }
  .mr-promo-left {}
  .mr-promo-label { font-size: 10.5px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; color: rgba(228,87,46,0.7); margin-bottom: 6px; }
  .mr-promo-code {
    font-family: 'Playfair Display', serif;
    font-size: 26px; font-weight: 700; color: var(--o); letter-spacing: .06em;
    margin-bottom: 4px;
  }
  .mr-promo-detail { font-size: 13px; color: rgba(246,242,236,0.55); line-height: 1.5; }
  .mr-promo-copy {
    background: var(--o); color: #fff; border: none; border-radius: 999px;
    padding: 10px 20px; font-size: 13px; font-weight: 700; cursor: pointer;
    font-family: 'Inter', sans-serif; flex-shrink: 0; transition: all .15s;
    margin-left: auto;
  }
  .mr-promo-copy:hover { opacity: .9; }
  .mr-promo-copy.copied { background: var(--g); }

  .mr-lea-btns { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; position: relative; z-index: 2; }
  .mr-lea-btn-main {
    background: var(--o); color: #fff; border: none; border-radius: 999px;
    padding: 15px 30px; font-size: 15px; font-weight: 700; cursor: pointer;
    font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 9px;
    box-shadow: 0 6px 20px rgba(228,87,46,0.4); transition: all .15s;
    text-decoration: none;
  }
  .mr-lea-btn-main:hover { transform: translateY(-1px); box-shadow: 0 10px 28px rgba(228,87,46,0.5); }
  .mr-lea-btn-contact {
    background: rgba(255,255,255,0.08); color: rgba(246,242,236,0.75);
    border: 1px solid rgba(255,255,255,0.15); border-radius: 999px;
    padding: 14px 24px; font-size: 14px; font-weight: 600; cursor: pointer;
    font-family: 'Inter', sans-serif; text-decoration: none; display: inline-flex;
    align-items: center; gap: 7px;
  }
  .mr-lea-note { font-size: 12px; color: rgba(246,242,236,0.3); margin-top: 14px; position: relative; z-index: 2; }

  /* BTNS NAV */
  .mr-nav { display: flex; justify-content: space-between; align-items: center; margin-top: 32px; gap: 12px; }
  .mr-btn-primary { background: var(--g); color: #F6F2EC; border: none; border-radius: 999px; padding: 13px 28px; font-size: 14.5px; font-weight: 700; cursor: pointer; font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 14px rgba(23,59,52,0.25); transition: all .15s; }
  .mr-btn-primary:hover { background: #0E2820; transform: translateY(-1px); }
  .mr-btn-secondary { background: transparent; color: var(--g); border: 1.5px solid var(--line); border-radius: 999px; padding: 12px 24px; font-size: 14px; font-weight: 600; cursor: pointer; font-family: 'Inter', sans-serif; }
  .mr-btn-secondary:hover { border-color: var(--g); }

  @media(max-width:640px) {
    .mr-grid, .mr-reseaux, .mr-lea-features { grid-template-columns: 1fr; }
    .mr-lea { padding: 28px 20px; }
    .mr-lea-btns { flex-direction: column; }
    .mr-lea-btn-main { width: 100%; justify-content: center; }
    .mr-promo { flex-direction: column; }
    .mr-promo-copy { margin-left: 0; width: 100%; text-align: center; }
  }
`;

const FORMATION = [
  {
    num: 'Partie 1',
    titre: "Pourquoi les réseaux sociaux peuvent tout changer, ou te faire perdre du temps",
    content: () => (
      <>
        <p>Les réseaux sociaux sont l'outil de visibilité le plus puissant jamais mis à la disposition des indépendants et des TPE. Pour la première fois, une personne seule peut toucher des milliers de prospects ciblés sans budget publicitaire.</p>
        <div className="mr-hl orange">Mais la plupart des créateurs postent dans le vide. Pas parce qu'ils manquent d'idées. Parce qu'ils n'ont pas de stratégie.</div>
        <p>Poster sans stratégie, c'est comme prospecter sans script : tu dépenses de l'énergie, tu génères peu de résultats, et tu finis par abandonner en pensant que "les réseaux, c'est pas pour toi".</p>
        <div className="mr-grid">
          {[
            { ico:'🎯', t:'Avec une stratégie', d:'Chaque post sert un objectif précis. Tu attires les bonnes personnes, tu crées de la confiance, tu convertis.' },
            { ico:'🎲', t:'Sans stratégie', d:'Tu publies quand tu penses à le faire. Tu changes de ton. Tu ne sais pas ce qui fonctionne.' },
          ].map((e,i) => <div key={i} className="mr-gi"><div className="mr-gi-ico">{e.ico}</div><div className="mr-gi-title">{e.t}</div><div className="mr-gi-desc">{e.d}</div></div>)}
        </div>
      </>
    )
  },
  {
    num: 'Partie 2',
    titre: "Choisir les bons réseaux, pas tous les réseaux",
    content: () => (
      <>
        <p>La première erreur est de vouloir être partout. <strong>Mieux vaut exceller sur un réseau que d'être invisible sur cinq.</strong> Le choix dépend de ta cible, de ton secteur et du type de contenu que tu peux produire régulièrement.</p>
        <div className="mr-reseaux">
          {[
            { ico:'📸', name:'Instagram', cible:'B2C, lifestyle, créatifs, coachs', desc:'Idéal pour la confiance et la notoriété. Le visuel est roi. Stories, Reels et carrousels pour l\'engagement.' },
            { ico:'💼', name:'LinkedIn', cible:'B2B, consultants, formateurs', desc:'Le réseau pro par excellence. Parfait pour asseoir ton expertise et générer des leads qualifiés.' },
            { ico:'🎵', name:'TikTok', cible:'B2C, jeune audience, fort volume', desc:'La portée organique la plus élevée du marché. Requiert une production vidéo régulière et du rythme.' },
            { ico:'👥', name:'Facebook', cible:'B2C local, 35-55 ans, communautés', desc:'Les groupes restent très efficaces pour les niches et les audiences locales.' },
            { ico:'📝', name:'LinkedIn + Newsletter', cible:'Experts, consultants B2B', desc:'La combinaison la plus efficace pour construire une audience fidèle et une autorité sectorielle.' },
            { ico:'🔍', name:'YouTube / SEO', cible:'Tous les secteurs', desc:'Contenu long format avec une durée de vie infinie. Investissement initial élevé mais rentabilité maximale.' },
          ].map((r,i) => (
            <div key={i} className="mr-reseau">
              <div className="mr-reseau-head"><span className="mr-reseau-ico">{r.ico}</span><span className="mr-reseau-name">{r.name}</span></div>
              <div className="mr-reseau-cible">{r.cible}</div>
              <div className="mr-reseau-desc">{r.desc}</div>
            </div>
          ))}
        </div>
      </>
    )
  },
  {
    num: 'Partie 3',
    titre: "Les 5 piliers de contenu qui structurent ta prise de parole",
    content: () => (
      <>
        <p>Une stratégie de contenu efficace repose sur <strong>5 piliers</strong>, des thématiques récurrentes qui couvrent tous les besoins de ton audience, de la découverte à la conversion.</p>
        <div className="mr-pilliers">
          {[
            ['Éducation', 'Tu partages ce que tu sais. Tu positionnes ton expertise, tu aides ton audience à progresser.', '30-35%'],
            ['Inspiration', 'Tu montres les transformations possibles, les résultats de tes clients, les coulisses de ton activité.', '20-25%'],
            ['Connexion', 'Tu humanises ta marque. Ton histoire, tes valeurs, ta vision, ce qui te différencie.', '15-20%'],
            ['Interaction', 'Tu poses des questions, tu crées des sondages, tu invites au débat. Tu construis une communauté.', '10-15%'],
            ['Conversion', 'Tu présentes ton offre, tes services, tes résultats. Tu incites à passer à l\'action.', '10-15%'],
          ].map(([titre, desc, pct], i) => (
            <div key={i} className="mr-pillier">
              <div className="mr-pillier-num">{i+1}</div>
              <div><strong>{titre} <span style={{color:'var(--o)',fontSize:12}}>{pct}</span></strong><span>{desc}</span></div>
            </div>
          ))}
        </div>
        <div className="mr-hl">L'équilibre entre ces piliers dépend de ton secteur et de ta cible. L'IA de Léa te recommandera la répartition optimale pour ton profil.</div>
      </>
    )
  },
  {
    num: 'Partie 4',
    titre: "Les 5 erreurs qui tuent une stratégie réseaux",
    content: () => (
      <>
        <div className="mr-erreurs">
          {[
            ['Être partout sans être nulle part', 'Disperser son énergie sur 5 réseaux avec 2 posts par mois sur chacun. Résultat : aucune communauté, aucune autorité.'],
            ['Poster uniquement quand on y pense', 'Sans calendrier, la régularité est impossible. Et l\'algorithme pénalise l\'irrégularité.'],
            ['Ne parler que de son offre', 'Les posts de vente pure ont le taux d\'engagement le plus bas. La vente doit représenter 10 à 15% du contenu maximum.'],
            ['Ignorer les données', 'Poster sans regarder les statistiques, c\'est conduire les yeux fermés. Ce qui fonctionne doit être amplifié.'],
            ['Copier ses concurrents', 'S\'inspirer est sain. Copier est contre-productif. Ton audience cherche ton point de vue unique, pas un clone.'],
          ].map(([titre, desc], i) => (
            <div key={i} className="mr-erreur">
              <span className="mr-erreur-x">✗</span>
              <div><strong style={{display:'block',marginBottom:3,color:'var(--d)'}}>{titre}</strong>{desc}</div>
            </div>
          ))}
        </div>
      </>
    )
  },
  {
    num: 'Partie 5',
    titre: "La suite : construis ta stratégie avec Léa",
    content: () => (
      <>
        <p>Tu as maintenant les bases d'une stratégie réseaux sociaux solide. La prochaine étape, c'est de passer à la construction et à l'exécution.</p>
        <div className="mr-hl">
          <strong>C'est exactement pour ça que Léa existe.</strong> Léa est l'assistant IA de Stratvente dédié à la stratégie réseaux sociaux, elle connaît ton secteur, analyse ta cible et génère ton plan de contenu sur mesure en quelques minutes.
        </div>
        <p>En t'inscrivant à Léa, tu bénéficies d'un accès exclusif au code promo réservé aux membres BrandStarter.</p>
      </>
    )
  }
];

export function ModuleReseaux({ onValidate }) {
  const [formationStep, setFormationStep] = useState(0);
  const [phase, setPhase] = useState('formation');
  const [copied, setCopied] = useState(false);

  const progress = phase === 'formation'
    ? ((formationStep + 1) / (FORMATION.length + 1)) * 100
    : 100;

  const copyCode = () => {
    navigator.clipboard.writeText('REMISE20').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <div className="mr">
      <style>{CSS}</style>

      <div className="mr-progress">
        <div className="mr-progress-fill" style={{width:`${progress}%`}}></div>
      </div>

      {/* ── FORMATION ── */}
      {phase === 'formation' && (
        <div className="mr-formation">
          {FORMATION.map((part, idx) => (
            idx <= formationStep && (
              <div key={idx} className="mr-part">
                <div className="mr-eyebrow">{part.num}</div>
                <h2>{part.titre}</h2>
                {part.content()}
              </div>
            )
          ))}
          <div className="mr-nav">
            {formationStep > 0
              ? <button className="mr-btn-secondary" onClick={() => setFormationStep(s => s-1)}>← Précédent</button>
              : <div/>
            }
            {formationStep < FORMATION.length - 1 ? (
              <button className="mr-btn-primary" onClick={() => setFormationStep(s => s+1)}>
                Partie suivante
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            ) : (
              <button className="mr-btn-primary" onClick={() => setPhase('lea')}>
                Découvrir Léa →
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── CTA LÉA ── */}
      {phase === 'lea' && (
        <div>
          <div className="mr-lea">
            <div className="mr-lea-eyebrow">Ta stratégie réseaux, propulsée par l'IA</div>
            <h2>Léa construit ton plan de contenu.<br/><em>En quelques minutes.</em></h2>
            <p className="mr-lea-desc">
              Léa est l'assistante IA de Stratvente dédiée à la stratégie réseaux sociaux. Elle analyse ton positionnement, choisit tes canaux, génère tes piliers de contenu et planifie tes publications. Sans prise de tête, sans page blanche.
            </p>

            <div className="mr-lea-features">
              {[
                { ico:'🎯', t:'Canaux recommandés', d:'Léa choisit les réseaux adaptés à ta cible et ton secteur.' },
                { ico:'📋', t:'Plan 30 jours', d:'Un calendrier de publications prêt à l\'emploi, semaine par semaine.' },
                { ico:'✍️', t:'Idées de contenu', d:'Des sujets, des angles, des formats, alignés sur ton persona.' },
                { ico:'📊', t:'Métriques et suivi', d:'Les indicateurs clés pour mesurer et améliorer ta stratégie.' },
              ].map((f,i) => (
                <div key={i} className="mr-lea-feat">
                  <div className="mr-lea-feat-ico">{f.ico}</div>
                  <div className="mr-lea-feat-title">{f.t}</div>
                  <div className="mr-lea-feat-desc">{f.d}</div>
                </div>
              ))}
            </div>

            {/* CODE PROMO */}
            <div className="mr-promo">
              <div className="mr-promo-left">
                <div className="mr-promo-label">Code exclusif BrandStarter</div>
                <div className="mr-promo-code">REMISE20</div>
                <div className="mr-promo-detail">20% de remise sur 6 mois d'abonnement payés en avance</div>
              </div>
              <button
                className={`mr-promo-copy ${copied ? 'copied' : ''}`}
                onClick={copyCode}
              >
                {copied ? '✓ Copié !' : 'Copier le code'}
              </button>
            </div>

            <div className="mr-lea-btns">
              <a
                href="https://plum-jackal-784583.hostingersite.com/"
                target="_blank"
                rel="noreferrer"
                className="mr-lea-btn-main"
              >
                Découvrir Léa
                <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
              <a
                href="mailto:commercial@stratvente.com?subject=Inscription Léa - BrandStarter&body=Bonjour, je souhaite m'inscrire à Léa suite au parcours BrandStarter. Code promo : REMISE20"
                className="mr-lea-btn-contact"
              >
                ✉️ Nous contacter pour s'inscrire
              </a>
            </div>
            <div className="mr-lea-note">
              L'accès à Léa est indépendant de BrandStarter. Contacte Stratvente pour toute question sur l'inscription.
            </div>
          </div>

          <div className="mr-nav" style={{marginTop:24}}>
            <button className="mr-btn-secondary" onClick={() => { setPhase('formation'); setFormationStep(FORMATION.length - 1); }}>
              ← Revoir le cours
            </button>
            <button className="mr-btn-primary" onClick={() => onValidate('MODULE_RESEAUX_COMPLETE: Cours réseaux sociaux complété, redirigé vers Léa')}>
              Valider et continuer →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
